/**
 * Supported sorting directions
 */
export enum SortDirection {
  Ascending = "asc",
  Descending = "desc",
}
